import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { patients } from "lobbie";
import { LabVendor } from "src/schemas/settings/labs/LabVendor";
import { ELabsVendorType } from "src/types/global_enums";

export interface ILabsOrderDrawerState {
    show: boolean;
    onCloseDrawer?: (canceled: boolean) => void;
    accountPatient?: patients.IAccountPatient; // TODO: this type (patients.IAccountPatient) doesn't match what is actually passed in
    appointmentId?: number;
    labVendors?: LabVendor[];
    isManual?: boolean;
    selectedLabVendor?: LabVendor;
}

export const initialStateLabsOrderDrawer: ILabsOrderDrawerState = {
    show: false,
    accountPatient: undefined,
    appointmentId: undefined,
    labVendors: undefined,
    onCloseDrawer: undefined,
    isManual: true,
    selectedLabVendor: undefined,
};

export const setLabOrderSelectedLabVendor = createAction<LabVendor | undefined>(
    "labsOrderDrawer/setSelectedLabVendor",
);

export const setLabOrderAccountPatient = createAction<patients.IAccountPatient | undefined>(
    "labsOrderDrawer/setAccountPatient",
);

export const setLabOrderAppointmentId = createAction<number | undefined>(
    "labsOrderDrawer/setAppointmentId",
);

export const setLabOrderIsManual = createAction<boolean | undefined>("labsOrderDrawer/setIsManual");

const labsOrderDrawerSlice = createSlice({
    name: "labsOrderDrawer",
    initialState: initialStateLabsOrderDrawer,
    reducers: {
        showLabsOrderDrawer: (
            _state,
            action: PayloadAction<Omit<ILabsOrderDrawerState, "show">>,
        ) => {
            return {
                ...action.payload,
                show: true,
            };
        },
        hideLabsOrderDrawer: (state) => {
            return {
                ...state,
                accountPatient: undefined,
                appointmentId: undefined,
                labVendors: undefined,
                isManual: true,
                onCloseDrawer: undefined,
                show: false,
                selectedLabVendor: undefined,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setLabOrderSelectedLabVendor, (state, action) => {
                const isManual =
                    action.payload === undefined ||
                    [ELabsVendorType.IN_HOUSE, ELabsVendorType.OTHER].some(
                        (type) => action.payload!.vendorType === type,
                    );
                return {
                    ...state,
                    selectedLabVendor: action.payload,
                    isManual,
                };
            })
            .addCase(setLabOrderAccountPatient, (state, action) => ({
                ...state,
                accountPatient: action.payload,
            }))
            .addCase(setLabOrderAppointmentId, (state, action) => ({
                ...state,
                appointmentId: action.payload,
            }))
            .addCase(setLabOrderIsManual, (state, action) => ({
                ...state,
                isManual: action.payload,
            }));
    },
});

export const { showLabsOrderDrawer, hideLabsOrderDrawer } = labsOrderDrawerSlice.actions;
export default labsOrderDrawerSlice;
